import * as Sentry from "@sentry/react";
import config from '../config/infrastructure_outputs.json';

const apiUrl = config.ApiUrl;
const isProduction = process.env.REACT_APP_SENTRY_ENVIRONMENT === "production";
const dsn = process.env.REACT_APP_SENTRY_DSN;

// Environment-specific configurations
const ENVIRONMENT_CONFIGS = {
  production: {
    ignorePatterns: [
      /\[object Object\]/,
      /ReactDOM\.render/,
      /mixpanel/i,
    ]
  },
  development: {
    ignorePatterns: [
      /\[HMR\]/,
      /hot update/i,
      /mixpanel/i,
      /\[object Object\]/
    ]
  }
};

const currentConfig = ENVIRONMENT_CONFIGS[process.env.REACT_APP_SENTRY_ENVIRONMENT as keyof typeof ENVIRONMENT_CONFIGS || 'production'];

export const initializeSentry = () => {
  if (!dsn) {
    console.warn('Sentry DSN not provided');
    return;
  }

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "development",
    sendDefaultPii: true,
    ignoreErrors: currentConfig.ignorePatterns,
    integrations: [
      Sentry.browserTracingIntegration({
        shouldCreateSpanForRequest(url) {
          return url.match(/\/(health|ensure-sandbox)\//) === null;
        },
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.extraErrorDataIntegration(),
      Sentry.httpClientIntegration(), // Monitor network requests
    ],
    tracesSampleRate: isProduction ? 0.5 : 1.0,
    tracePropagationTargets: ["localhost", apiUrl],
    replaysSessionSampleRate: 0.5, // TODO: later when we are stable we should reduce that to 0.1 maybe
    replaysOnErrorSampleRate: 1.0,
  });

};